import { TypePolicy } from "@apollo/client";

const LastViewTypePolicy: TypePolicy = {
  keyFields: ["slideId"],
  merge: true,
};

export default LastViewTypePolicy;
